import { DatePicker, Form, Select } from 'antd'
import { useMemo } from 'react'

import { SingleQuestionType } from '@/domain/model/question'
import FormAntd from '@/ui/form/antd/FormAntd'
import { getFilterOption } from '@/utils/getFilterOption'

type RenderFieldsProps = {
  selectedQuestionId: string
  selectedOperator?: string
  questions: SingleQuestionType[]
  name: (string | number)[]
}
export const ConditionRenderFields = ({
  selectedQuestionId,
  selectedOperator,
  questions,
  name,
}: RenderFieldsProps) => {
  const selectedQuestion = useMemo(
    () =>
      questions.find((item) => String(item.id) === String(selectedQuestionId)),
    [questions, selectedQuestionId]
  )

  const questionChoices = useMemo(
    () =>
      questions
        .find((question) => String(question.id) === String(selectedQuestionId))
        ?.choices?.map((item, index) => ({
          label: [index + 1, item.text].join('. '),
          value: String(item.id),
        })),
    [questions, selectedQuestionId]
  )

  if (['IS_FILLED', 'IS_EMPTY'].includes(selectedOperator || '')) {
    return <i />
  }

  if (!selectedQuestion) {
    return (
      <Form.Item noStyle className="mb-0 w-full" name={name}>
        <Select
          showSearch
          filterOption={(input, option) => getFilterOption(input, option)}
          options={questionChoices}
          placeholder="Expected Answer"
        />
      </Form.Item>
    )
  }

  if (selectedQuestion?.type === 'datetime') {
    return (
      <Form.Item noStyle className="mb-0 w-full" name={name}>
        <DatePicker
          className="w-full"
          format={{
            format: 'MM/DD/YYYY',
            type: 'mask',
          }}
          placeholder="Expected Answer"
        />
      </Form.Item>
    )
  }

  if (
    selectedQuestion?.type === 'number' ||
    selectedQuestion?.subtype === 'calculation'
  ) {
    return (
      <Form.Item noStyle className="mb-0 w-full" name={name}>
        <FormAntd.Input
          className="bg-white"
          placeholder="Expected Answer"
          type="number"
        />
      </Form.Item>
    )
  }

  if (selectedQuestion?.type === 'checkbox') {
    return (
      <Form.Item noStyle className="mb-0 w-full" name={name}>
        <Select
          showSearch
          filterOption={(input, option) => getFilterOption(input, option)}
          mode="multiple"
          options={questionChoices}
        />
      </Form.Item>
    )
  } else {
    return (
      <Form.Item noStyle className="mb-0 w-full" name={name}>
        <Select
          showSearch
          filterOption={(input, option) => getFilterOption(input, option)}
          options={questionChoices}
          placeholder="Expected Answer"
        />
      </Form.Item>
    )
  }
}
